<template>
  <div class="CEditor">
    <div class="main" :id="id" :style="{
      'min-height': minHeight + 'px',
      'overflow-x': 'auto'
    }"></div>
  </div>
</template>

<script>
// TinyMCE 中文文档：http://tinymce.ax-z.cn
import { mapState } from 'vuex'
import { mathmlToImg } from '@/utils/tools'
import addDot from './tinymce/plugins/addDot'
import addWave from './tinymce/plugins/addWave'
import indent2em from './tinymce/plugins/indent2em'
// import hwOssMixins from "@/mixins/hwOssMixins";
import { Base64 } from 'js-base64';
var tinymce = window.tinymce

export default {
  name: 'CEditor',
  // mixins: [hwOssMixins],
  props: {
    id: {
      default: () => 'tinymce',
      required: false,
      type: String
    },
    value: {
      default: () => '',
      required: false,
      type: String
    },
    noAccept: {
      default: 'image/svg+xml',
      type: String
    },
    accept: { // 文件类型
      default: 'image/jpeg, image/png',
      type: String
    },
    maxSize: { // 大小
      default: 1024 * 1024 * 2,
      type: Number
    },
    itemName: {
      default: '',
      type: String
    },
    minHeight: {
      type: Number,
      default: 120
    },
    curStep: {
      type: Number,
      default: -1
    },
    curSub: {
      type: Number,
      default: -1
    },
  },
  data () {
    return {
      bucket: 'jty-open-new',
      loading: false,
      noEdit: true, // 解决光标一直回到最左侧的问题
      isInit: true
    }
  },
  mounted () {
    tinymce = window.tinymce
  },
  watch: {
    // 切换题目、小题、选项时， noEdit 置为 true
    'curStep' () {
      this.noEdit = true
    },
    'curSub' () {
      this.noEdit = true
    },
    value: {
      handler (newVal) {
        let newoptions = ''
        setTimeout(() => {
          if (this.noEdit) {
            newoptions = this.dealQuestionIn(newVal);
            tinymce.get(this.id) && tinymce.get(this.id).setContent(newoptions)
          }
        }, 100);
      },
      immediate: false
    }
  },
  methods: {
    // 内容传入富文本的时候做些处理操作（拆解的时候标签不齐）, 第一次加载内容的处理和编辑时候的处理不一样
    dealQuestionIn (val, type = 'init') {
      if (val) {
        // 替换图片链接
        let newimgsrc = 'src="http://jty-xbzyk.obs.cn-north-4.myhuaweicloud.com/'
        let reg = new RegExp('src="/', 'g')
        let newoptions = val.replace(reg, newimgsrc)
        newoptions = newoptions.replace(/http:\/\/jty/g, 'https://jty');
        // 去掉alt
        let altReg = /alt="[^<>]*?"/g;
        newoptions = newoptions.replace(altReg, '')
        // 去掉空行
        newoptions = newoptions.replace(/^<p[^<>]*?><\/span><\/p>/g, '')
        // 去掉颜色
        newoptions = newoptions.replace(/color:/g, 'colorFc:')
        // img的name转mml + latex
        // newoptions = newoptions.replace(/(<img[^<>]*?)(name[\s=]*?".*?")([^<>]*?)(nickName[\s=]*?".*?")([^<>]*?>)/g, ($0, $1, $2, $3, $4, $5) => {
        //   let match1 = $2.match(/name="([^"]+)"/);
        //   let name1 = match1 ? match1[1] : null;
        //   let mml = ''
        //   if (name1) {
        //     mml = Base64.decode(name1)
        //   }
        //   let match2 = $4.match(/nickName="([^"]+)"/);
        //   let name2 = match2 ? match2[1] : null;
        //   let tex = ''
        //   if (name2) {
        //     tex = name2
        //   }
        //   return $1 + ' class="Wirisformula" data-mathml="'+ mathmlToImg(mml) + '"' + $3 + ' data-latex="'+ tex + '"' + $5;
        // })
        newoptions = newoptions.replace(/<dot>(.*?)<\/dot>/g, "<bdo class='dot'>$1</bdo>");
        newoptions = newoptions.replace(/<wave>(.*?)<\/wave>/g, "<bdo class='wave'>$1</bdo>");
        if (type === 'edit') {
          return newoptions
        }
        // 选项去掉结尾的不完全p 和 span标签
        if (this.itemName === 'option') {
          newoptions = newoptions.replace(/<span[^\/>]*?>$/g, '')
          newoptions = newoptions.replace(/<p[^\/>]*?>$/g, '')
        }
        // 去掉长空格
        // let blankSpanReg = /<span style="width[^<>]*?display[^<>]*?inline-block[^<>]*?-aw-tabstop-align[^<>]*?-aw-tabstop-pos[^<>]*?">&nbsp;<\/span>/g;
        // newoptions = newoptions.replace(blankSpanReg, '')
        // 第三方题目 和 选项不包
        if (!/^<p[^<>]*?vertical-align[^<>]*?>/.test(newoptions) && this.itemName !== 'option') {
          newoptions = '<p style="vertical-align: middle;">' + newoptions + '</p>';
        }
        // 处理下图片尺寸
        let imgReg = /(<img[^<>]*?width[\s=]*?")(\d*?)("[^<>]*?height[\s=]*?")(\d*?)("[^<>]*?>)/g;
        if (this.$route.name === 'proofreadV3' && imgReg.test(newoptions)) {
          newoptions = newoptions.replace(imgReg, ($0, $1, $2, $3, $4, $5) => {
            let width = +$2;
            let max = 700;
            if (width !== 0 && width <= max) {
              return $0;
            }
            let height = max * (+$4 / width)
            width = max;
            return $1 + width + $3 + height + $5;
          })
        }
        return newoptions
      } else {
        return ""
      }
    },
    mountedInit () {
      const _this = this
      _this.loading = true
      let forced_root_block = this.itemName === 'option' ? '' : 'p';
      return new Promise((resolve, reject) => {
        addDot(tinymce)
        addWave(tinymce)
        indent2em(tinymce)
        const initData = Object.assign(
          {
            selector: '#' + this.id, // 指定初始化Tinymce的元素
            inline: true,
            content_css: "/static/tinymce/skins/custom-conent.css", // 自定义编辑区域内的样式
            language_url: "/static/tinymce/zh_CN.js", // 变更语言，语言文件必须是网站的绝对路径
            language: 'zh_CN', // 设置中文
            indentVal: '2em', // 配置首行缩进
            paste_enable_default_filters: false, // 是否开启默认过滤器(开启后会对粘贴内容进行过滤)
            autoresize_min_height: 150,
            // forced_root_block: '',
            forced_root_block: forced_root_block,
            forced_root_block_attrs: {
              style: 'vertical-align: middle;'
            },
            formats: {
              // 自定义格式清除
              removeformat: [
                {
                  selector: 'b,strong,em,i,font,u,strike,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
                  remove: 'all',
                  // split: true,
                  expand: false,
                  block_expand: true,
                  deep: true
                },
                {
                  selector: 'p,span',
                  attributes: [
                    'style',
                    'class'
                  ],
                  remove: 'none',
                  // split: true,
                  expand: false,
                  deep: true
                }
              ]
            },
            skin_url: '/static/tinymce/skins/lightgray', // 设置皮肤，皮肤用于更改编辑器的外观，例如颜色、边距、填充、字体、图标等
            // plugins: ['code', 'indent2em', 'addDot', 'addWave', 'table', 'paste', 'image', 'charmap', 'fullscreen', 'preview', 'textcolor', 'contextmenu', 'autoresize'],
            // toolbar1: 'fullscreen bold italic underline subscript superscript removeformat image table charmap alignleft aligncenter alignright',
            plugins: ['code', 'indent2em', 'addDot', 'addWave', 'table', 'paste', 'charmap', 'fullscreen', 'preview', 'textcolor', 'contextmenu', 'autoresize'],
            toolbar1: 'fullscreen bold italic underline subscript superscript removeformat table charmap alignleft aligncenter alignright',
            toolbar2: 'fontsizeselect fontselect indent2em addDot addWave undo redo',
            fontsize_formats: '8px 10px 12px 14px 18px 24px 36px',
            font_formats: '宋体=宋体;楷体=楷体;微软雅黑=微软雅黑;Times New Romance=Times New Romance;Helvetica Neue=Helvetica Neue;Helvetica=Helvetica;PingFang SC=PingFang SC;Hiragino Sans GB=Hiragino Sans GB;Microsoft YaHei=Microsoft YaHei;Verdana=verdana,geneva;Helvetica=helvetica;Arial=arial,helvetica,sans-serif;',
            menubar: false, // 是否显示开启菜单栏
            contextmenu: 'cut copy paste indent2em addDot addWave', // 右键菜单工具
            image_advtab: true, // 允许为图片添加自定义样式、边距、边框
            paste_data_images: true, // 粘贴的同时能把内容里的图片自动上传
            paste_merge_formats: true, // 启用粘贴插件合并格式功能
            statusbar: false, // 是否显示底部状态栏（显示字数）
            images_reuse_filename: true, // 上传后使用图片真实文件名称
            automatic_uploads: true, // 启用或者禁止自动上传由 data URL 或者 blob URls表示的图像，关闭后，直接拖放在编辑区域的图片不会上传到CDN，而是以Base:64格式保存在后台数据库中
            extended_valid_elements: 'maction[actiontype|class|id|style|style|mathbackground|mathcolor|selection],math[xmlns|class|id|style|dir|href|mathbackground|mathcolor|display|mode|overflow],menclose[class|id|style|href|mathbackground|mathcolor|notation],merror[class|id|style|href|mathbackground|mathcolor],mstyle,mglyph[src|alt],ms[lquote|rquote],mspace[width],mfrac[bevelled|class|id|style|denomalign|href|linethickness|mathbackground|mathcolor|numalign],mglyph[valign|width|src|mathbackground|href|height|class|id|style|alt],msqrt,msup,mfenced[class|id|style|href|mathbackground|mathcolor|close|open|separators],mrow,mtable[columnalign|side],mtr,mtd,mn,mo,mi[class|id|style|dir|href|mathbackground|mathcolor|mathvariant|mathsize],mlabeledtr,mmultiscripts,mover[accent],mpadded,mphantom,mroot,msub,msubsup[mathbackground|mathcolor|subscriptshift|superscriptshift],munder[accent],munderover,semantics[definitionURL|encoding|cd|name|src],mtext',
            // 初始化回调
            init_instance_callback(editor) { },
            // 图片上传
            images_upload_handler (blobInfo, success, failure) {
              let localFile = blobInfo.blob()
              if (localFile.size > _this.maxSize) {
                failure('文件体积过大')
                return;
              }
              if (_this.noAccept.indexOf(localFile.type) >= 0) {
                console.log('svg不操作')
                return;
              }
              if (_this.accept.indexOf(localFile.type) === -1) {
                failure('图片格式错误')
                return;
              }
              if (!(localFile instanceof window.File)) {
                let reader = new FileReader();
                reader.onload = () => {
                  let temp = reader.result;
                  localFile = new File([temp], localFile.name ,{type: localFile.type, lastModified: localFile.lastModified, size:localFile.size  })
                  _this.uploadPic(localFile, success, failure)
                }
                reader.readAsArrayBuffer(localFile)
              }
              else {
                _this.uploadPic(localFile, success, failure)
              }
            },
            paste_postprocess: function (plugin, args) {
              // 去掉字体和大小
              // _this.dealNode(args.node);
              // 去掉外面包裹的第一个p标签
              if (/<p[^<>]*?class=\"MsoNormal\"[^<>]*?>(.*?)<\/p>/.test(args.node.innerHTML)) {
                args.node.innerHTML = args.node.innerHTML.replace(/<p[^<>]*?class=\"MsoNormal\"[^<>]*?>(.*?)<\/p>/, '$1')
              }
              if (/vertical-align:\s*(sub|supper)/.test(args.node.innerHTML)) {
                args.node.innerHTML =  args.node.innerHTML + '<span>&nbsp;</span>'
              }
              args.node.innerHTML = args.node.innerHTML.replace(/&nbsp;/ig, " ");
              args.node.setAttribute('id', '42')
            },
            // 双向绑定，编辑器检测到有变化时调用 $emit(‘input’, value) 将数据写出到父组件
            setup: function (editor) {
              editor.on('input undo redo execCommand KeyUp', function (e) {
                _this.noEdit = false
                let newoptions = editor.getContent();
                let wirisReg = /<(img[^<>]*?class="Wirisformula"[^<>]*?)(style="[^<>]*?")([^<>]*?)>/g;
                let wirisStyle = '<$1style="vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;"$3>'
                newoptions = newoptions.replace(wirisReg, wirisStyle)
                newoptions = newoptions.replace(/<bdo class="dot">(.*?)<\/bdo>/g, "<dot>$1</dot>");
                newoptions = newoptions.replace(/<bdo class="wave">(.*?)<\/bdo>/g, "<wave>$1</wave>");
                _this.$emit('input', newoptions)
              })
              editor.on('focus', function (e) {
                _this.noEdit = false
                if (editor.getContent().indexOf('该试题待录入...') !== -1) {
                  editor.setContent('')
                }
                _this.$emit('input', editor.getContent())
              })
              editor.on('blur', function (e) {
                _this.noEdit = true
              })
            }
          },
        )
        tinymce.init(initData).then(() => {
          const value = _this.dealQuestionIn(_this.value)
          tinymce.get(_this.id).setContent(value)
          _this.loading = false
          _this.isInit = false
          resolve()
        })
      })
    },
    uploadPic (localFile, success, failure) {
      // 走oss前端上传
      // this.doUpload({
      //   file: localFile,
      //   onProgress: () => {}
      // }).then(res => {
      //   if (!res.url) {
      //     failure('上传失败: error')
      //     return
      //   }
      //   // 使用CND地址替换<image>标签的src属性，调用success方法并传入图片地址
      //   const imgURL = res.url.replace('http:', 'https:')
      //   success(imgURL)
      //   this.$emit('input', tinymce.get(this.id).getContent())
      //   setTimeout(() => {
      //     tinymce.get(this.id).focus();
      //   }, 100);
      // }).catch(() => {
      //   failure('上传失败: error')
      // })
    },
    dealNode(node) {
      let nodeType = node.nodeType;
      if (nodeType === 1) {
        node.face && (node.face = '');
        node.style.fontSize  && (node.style.fontSize = '');
        node.style.fontFamily  && (node.style.fontFamily = '');
        let childNodes = node.childNodes;
        for(let i = 0; i < childNodes.length; i++) {
          this.dealNode(childNodes[i])
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor4/CEditor.vue